/* import __COLOCATED_TEMPLATE__ from './provider-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { get } from 'embercom/lib/ajax';
import { submitOAuthForm } from 'embercom/lib/oauth/form-submission';
import type Router from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type NotificationsService from 'embercom/services/notifications-service';

interface Args {
  onClose: () => void;
}

interface Provider {
  id: string;
  icon: string;
  titleKey: string;
  onClick: () => void;
}

export default class AuthenticationProviderModal extends Component<Args> {
  @service declare router: Router;
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare notificationsService: InstanceType<typeof NotificationsService>;

  get providers(): Provider[] {
    return [
      {
        id: 'custom',
        icon: 'integrations/custom',
        titleKey: 'settings.custom-authentication-tokens.provider-modal.custom.title',
        onClick: () => this.selectCustomToken(),
      },
      {
        id: 'salesforce',
        icon: 'integrations/salesforce',
        titleKey: 'settings.custom-authentication-tokens.provider-modal.salesforce.title',
        onClick: () => this.connectOAuth('salesforce', false),
      },
      {
        id: 'salesforce-sandbox',
        icon: 'integrations/salesforce',
        titleKey: 'settings.custom-authentication-tokens.provider-modal.salesforce-sandbox.title',
        onClick: () => this.connectOAuth('salesforce', true),
      },
      {
        id: 'hubspot',
        icon: 'integrations/hubspot',
        titleKey: 'settings.custom-authentication-tokens.provider-modal.hubspot.title',
        onClick: () => this.connectOAuth('hubspot', false),
      },
    ];
  }

  @action
  selectCustomToken() {
    this.args.onClose();
    this.router.transitionTo('apps.app.settings.app-settings.authentication.new');
  }

  @action
  async connectOAuth(provider: 'salesforce' | 'hubspot', isSandbox = false) {
    this.args.onClose();

    try {
      let url = `/ember/custom_authentication/oauth/${provider}/connect?app_id=${this.appService.app.id}&sandbox=${isSandbox}`;
      let response = await get(url);

      submitOAuthForm(response.authorization_url);
    } catch (error: unknown) {
      this.notificationsService.notifyResponseError(error, {
        default: this.intl.t(`settings.custom-authentication-tokens.${provider}.connect-error`),
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::AppSettings::Authentication::ProviderModal': typeof AuthenticationProviderModal;
    'new-settings/app-settings/authentication/provider-modal': typeof AuthenticationProviderModal;
  }
}
